"use client"

const DashboardSidebar = ({ salesChartData }) => {
  if (!salesChartData) return null

  const {
    top_destination,
    best_performing_sku,
    best_sales_month,
    total_wholesale_days = 0,
    total_wholesale_sales = 0,
    avg_wholesale_sales = 0,

    total_business_days = 0,
    total_business_sales = 0,
    avg_business_sales = 0
    } = salesChartData


  return (
    <div
      style={{
        background: "#fff",
        borderRadius: "12px",
        padding: "20px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
        height: "fit-content",
        position: "sticky",
        top: "10px"
      }}
    >
      <h3
        style={{
          margin: "0 0 20px 0",
          fontSize: "18px",
          fontWeight: "700",
          color: "#B9366D",
          borderBottom: "2px solid #f0f0f0",
          paddingBottom: "10px"
        }}
      >
        Key Insights
      </h3>

      <InsightBlock
        title="Top Destination"
        label={top_destination?.destination_store_name}
        value={`${top_destination?.units?.toLocaleString()} units`}
      />

      <InsightBlock
        title="Best Performing SKU"
        label={best_performing_sku?.sku_code}
        value={`${best_performing_sku?.units?.toLocaleString()} units`}
      />

      <InsightBlock
        title="Best Sales Month"
        label={new Date(best_sales_month?.month + "-01").toLocaleDateString(
          "en-US",
          { month: "short", year: "numeric" }
        )}
        value={`${best_sales_month?.units?.toLocaleString()} units`}
      />

      {/* Sales Analysis */}
      <div
        style={{
          background: "#f8f9fa",
          borderRadius: "8px",
          padding: "15px",
          marginTop: "20px"
        }}
      >
        <SectionTitle text="Sales Analysis (Current Month)" />

        <Metric label="Total Wholesale Days" value={`${total_wholesale_days} days`} />
        <Metric
          label="Total Sales on Wholesale Days"
          value={`${(total_wholesale_sales || 0).toLocaleString()} units`}
        />
        <Metric label="Avg. Sales on Wholesale Days" value={`${avg_wholesale_sales.toLocaleString()} units`} />

        <Metric label="Total Business Days" value={`${total_business_days} days`} />

        <Metric
          label="Total Sales on Business Days"
          value={`${(total_business_sales || 0).toLocaleString()} units`}
        />

        {/* <Metric
          label="Avg. Sales on Wholesale Days"
          value={`${(avg_wholesale_sales || 0).toLocaleString()} units`}
        /> */}


        <Metric
          label="Avg. Sales on Business Days"
          value={`${(avg_business_sales || 0).toLocaleString()} units`}
        />
        {/* <Metric
          label="Avg. Sales on Business Days"
          value={`${(avg_business_sales || 0).toLocaleString()} units`}
        /> */}
      </div>
    </div>
  )
}

/* ---------- Small Reusable UI Blocks ---------- */

const InsightBlock = ({ title, label, value }) => (
  <div style={{ marginBottom: "20px" }}>
    <div style={{ fontSize: "12px", color: "#666", marginBottom: "4px" }}>
      {title}
    </div>
    <div style={{ fontSize: "16px", fontWeight: "600", color: "#333" }}>
      {label}
    </div>
    <div style={{ fontSize: "14px", color: "#B9366D", fontWeight: "600" }}>
      {value}
    </div>
  </div>
)

const SectionTitle = ({ text }) => (
  <div
    style={{
      fontSize: "14px",
      fontWeight: "600",
      color: "#B9366D",
      marginBottom: "12px",
      borderBottom: "1px solid #e0e0e0",
      paddingBottom: "8px"
    }}
  >
    {text}
  </div>
)

const Metric = ({ label, value }) => (
  <div style={{ marginBottom: "15px" }}>
    <div style={{ fontSize: "11px", color: "#666" }}>{label}</div>
    <div style={{ fontSize: "14px", fontWeight: "600", color: "#333" }}>
      {value}
    </div>
  </div>
)

export default DashboardSidebar
